var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('mavon-editor',{ref:"md",attrs:{"toolbarsFlag":!_vm.readOnly,"defaultOpen":_vm.readOnly?'preview':'edit',"ishljs":true,"subfield":!_vm.readOnly,"editable":!_vm.readOnly},on:{"save":_vm.save,"imgAdd":_vm.imgAdd},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-203bdcea","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/GykjMarkDown/GykjMarkDown.vue
// module id = 47
// module chunks = 0